import Icon from '@/common/components/dataDisplay/Icon';
import { Link as LinkIcon } from 'lucide-react';
import React, { ReactNode } from 'react';
import Btn from './Btn';

type Props = {
  /**
   * React children, usually text.
   */
  children: ReactNode;
}

/**
 * A button with a link icon as prefix.
 */
const LinkButton: React.FunctionComponent<Props> = (props): JSX.Element => {
  const { children } = props;
  return (
    <Btn>
      <Icon icon={LinkIcon} />
      {children}
    </Btn>
  );
};

export default LinkButton;
